import React from "react";
import Card from "./Card";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";

const SuggestedArticles = () => {
    const suggestedArticleRef = db.collection("specialArticles");
    const query = suggestedArticleRef.where("type", "==", "suggested");
    const [suggested, loading, error] = useCollectionData(query);
    return (
        <section className="row">
            <h2>Suggested Articles</h2>
            {loading && <h1>Loading...</h1>}
            {error && <h1>{error}</h1>}
            <div className="container">
                <div className="row">
                    {suggested && suggested[0].posts.map((title, i) => (
                        <div key={i} className="col-sm-4">
                            <Card title={title}/>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default SuggestedArticles;
